import { gql } from '@apollo/client';

export const listDCRs = gql`
    query listDCRs(
        $filter: SearchableDCRsFilterInput
        $sort: [SearchableCoreDataSortInput]
        $limit: Int
        $nextToken: Int
    ) {
        listDCRs(filter: $filter, sort: $sort, limit: $limit, nextToken: $nextToken) {
            items {
                pk
                sk
                dcrId
                siteId
                patientId
                studyInstanceId
                studyEventRef
                studyActivityInstanceId
                studyActivityRef
                type
                status
                critical
                assignedTo
                siteIdentifier
                eventName
                activityName
                site {
                    data
                }
                reason {
                    field
                    reasonId
                    reasonText
                }
                patient {
                    screeningIdentifier
                    prescreeningIdentifier
                    randomizationIdentifier
                }
                inputs {
                    __typename
                    ... on TransferSwapActivityData {
                        destinationPatientId
                        destinationStudyEventInstanceId
                        destinationStudyActivityInstanceId
                    }
                    ... on ChangeData {
                        inputUpdateSubjectStudyActivityInstance
                        inputSaveEditCheck
                    }

                    ... on PatientSiteTransfer {
                        newSiteId
                    }
                    ... on Exception {
                        description
                    }
                    ... on ChangeVisitDate {
                        updatedStartAt
                        updatedEndAt
                        appointmentId
                    }
                    ... on ChangeTranscriptionDetails {
                        newReasonForTranscription
                        newDataCollectionStartDate
                        newDataCollectionStartTime
                        newDataCollectionEndDate
                        newDataCollectionEndTime
                    }
                }
                workflow {
                    step
                    status
                    type
                    data {
                        roles
                        createdAt
                        createdBy
                        updatedAt
                        updatedBy
                        updatedByRoleId
                        createdByName {
                            firstName
                            lastName
                        }
                        updatedByName {
                            firstName
                            lastName
                        }
                        rejectionReason
                    }
                }
                comment
                createdByName {
                    firstName
                    lastName
                }
                updatedBy
                createdAt
                createdByRole
                taskId
            }
            statusMetrics {
                pendingReviewTotal
                pendingApprovalTotal
                completedTotal
                rejectedTotal
            }
            totalItems
        }
    }
`;

export const getDCRConfigQuery = gql`
    query getDCRConfig($input: InputGetDCRConfig!) {
        getDCRConfig(input: $input) {
            pk
            sk
            configVersion
            configStatus
            viewRoles
            dcrTypeConfigs {
                pk
                sk
                selfService
                status
                dcrType
                openRoles
                approveRoles {
                    order
                    roleId
                }
                createdByName {
                    firstName
                    lastName
                }
                updatedByName {
                    firstName
                    lastName
                }
                updatedAt
            }
        }
    }
`;
